"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IDifficultyRating = void 0;
var IDifficultyRating;
(function (IDifficultyRating) {
    IDifficultyRating["Easy"] = "easy";
    IDifficultyRating["Moderate"] = "moderate";
    IDifficultyRating["Strenuous"] = "strenuous";
})(IDifficultyRating || (exports.IDifficultyRating = IDifficultyRating = {}));
//# sourceMappingURL=difficulty-rating.js.map